<template>
    <ai-form-text-box-dictionary
        ref="tboxDepEmpRef"
        title="Кто менял"
        placeholder="Подразделения и сотрудники"
        :field-name-id="meta.fieldKey"
        :field-name-text="meta.fieldText"
        :key-expr="meta.keyExpr"
        :value-expr="meta.keyExpr"
        :display-expr="meta.displayExpr"
        :data-source="dict"
        :custom-buttons="customButtons"
        :need-modified-class="false"
        @popup-shown="popupShown"
    >
        <dep-emp-tree ref="depEmpTreeRef" :meta="meta" @who-change-active="onSelectTreeItem" />

        <dx-toolbar-item location="after" toolbar="bottom">
            <dx-button text="Выбрать" @click="chooseItem" />
        </dx-toolbar-item>

        <dx-toolbar-item location="after" toolbar="bottom">
            <dx-button text="Отмена" @click="hide" />
        </dx-toolbar-item>
    </ai-form-text-box-dictionary>
</template>

<script setup>
import { ref, computed, reactive, inject, onMounted } from 'vue';

import { DxButton } from 'devextreme-vue/button';
import { DxToolbarItem } from 'devextreme-vue/popup';

import AiFormTextBoxDictionary from '@/components/card-component/ai-form-text-box-dictionary.vue';
import DepEmpTree from '@/views/history/history-card/components/dep-emp-tree.vue';

const depEmpTreeRef = ref(null);
const tboxDepEmpRef = ref(null);
const popupInstance = ref(null);

const userData = inject('userData');
const conditions = inject('conditions');

const meta = {
    // используется только в input, в popup не используется
    fieldKey: 'who_id',
    fieldText: 'who_name',

    // используется в input и popup
    keyExpr: 'key',
    displayExpr: 'name',
    parentIdExpr: 'parent_id',

    // используется только в popup
    searchHint: null,
    valueChangeEvent: 'keyup',
    rootValue: null,
    dataStructure: 'plain',
    selectByClick: true,
    expandEvent: 'dblclick',
    selectionMode: 'single',
    itemTemplate: 'item-template',
};

// активный элемент в дереве
const lastActive = {
    id: null,
    name: null,
};

const dict = computed(() => {
    let res = [];
    if (conditions.value) {
        res = [
            {
                key: conditions.value.who_id,
                name: conditions.value.who_name,
            },
        ];
    }
    return res;
});

const customButtons = reactive([
    {
        name: 'clearButton',
        options: {
            visible: true,
            disabled: false,
            icon: 'close',
            onClick: async () => {
                conditions.value.who_id = null;
                conditions.value.who_name = null;
            },
        },
    },
]);

onMounted(() => {
    popupInstance.value = tboxDepEmpRef.value?.popupInstance;
});

const hide = () => {
    popupInstance.value.instance().hide();
};

// клик на элемент дерева
const onSelectTreeItem = itemData => {
    lastActive.id = itemData.key;
    lastActive.name = itemData.name;
};

// клик на кнопку "Выбрать" в popup
const chooseItem = async () => {
    conditions.value = { ...conditions.value, ...{ who_id: lastActive.id, who_name: lastActive.name } };
    userData.value = conditions.value;

    hide();
};

const popupShown = () => {
    if (conditions.value?.who_id) {
        depEmpTreeRef.value.selectNode(conditions.value.who_id);
    }
};

</script>
